import type { ProductCardProps } from '@hypercodestudio/basler-components';

// Read-only skeleton template. Labels are intentionally empty: the card renders
// loading placeholders (isLoading + attributesLoadingLines), so no visible text
// is needed and we avoid hardcoded, untranslated strings.
const loadingCardTemplate: ProductCardProps = Object.freeze<ProductCardProps>({
  product: {
    id: '',
    name: '',
    variantName: '',
    description: '',
    price: -1,
    priceText: '',
    pricePrefix: '',
    attributes: [
      { key: 'sensor', label: '', value: '' },
      { key: 'framerate', label: '', value: '' },
      { key: 'resolution', label: '', value: '' },
      { key: 'interface', label: '', value: '' },
      { key: 'sensorformat', label: '', value: '' }
    ],
    media: {
      type: 'image',
      content: {
        src: '',
        width: 400,
        height: 300
      }
    }
  },
  isLoading: true,
  loadingLines: 3,
  attributesLoadingLines: 5
});

/**
 * ProductList skeleton items aligned with PDP related-products cards (size="full").
 * Each item is a shallow clone so list keys stay unique and mutations cannot leak
 * across cards.
 */
export function createProductListLoadingItems(
  itemCount: number
): ProductCardProps[] {
  return Array.from(
    { length: itemCount },
    (_value: unknown, index: number) => ({
      ...loadingCardTemplate,
      product: {
        ...loadingCardTemplate.product,
        id: `skeleton-${index}`,
        attributes: loadingCardTemplate.product.attributes.map((attribute) => ({
          ...attribute
        }))
      }
    })
  );
}
